import { useState } from 'react';

import { type CatalogTypeModel } from '../../models/Catalog';

import { CatalogEdit } from './CatalogEdit';
import { CatalogList } from './CatalogList';

type ViewMode = 'list' | 'create' | 'edit';

export const CatalogPage = () => {
  const [viewMode, setViewMode] = useState<ViewMode>('list');
  const [selected, setSelected] = useState<CatalogTypeModel | undefined>();

  const handleCreate = () => {
    setViewMode('edit');
  };

  const handleEdit = (row: CatalogTypeModel) => {
    setSelected(row);
    setViewMode('edit');
  };

  const handleCancel = () => {
    setSelected(undefined);
    setViewMode('list');
  };

  const handleFinish = () => {
    setSelected(undefined);
    setViewMode('list');

    // se vuelve cargar la lista para refrescar la información
    // refetch();
  };

  return (
    <>
      {viewMode == 'edit' && (
        <CatalogEdit handleCancel={handleCancel} handleFinish={handleFinish} original={selected} />
      )}

      {viewMode == 'list' && <CatalogList handleEdit={handleEdit} handleCreate={handleCreate} />}
    </>
  );
};
